// extracted by mini-css-extract-plugin
export default {"experienceList":"resume_experienceList__wBO8j","experienceDescription":"resume_experienceDescription__PVsHj","navigation":"resume_navigation__6a+-5","jobs":"resume_jobs__FKaPk"};